import { createContext, useState } from 'react';

interface IModalProvider {
  children: React.ReactNode;
  showModal: boolean;
  setShowModal: (show: boolean) => void;
}

interface IModalContext {
  setShowModal: (show: boolean) => void;
  showModal: boolean;
  showSuccessComponent: boolean;
  setShowSuccessComponent: (showSuccessComponent: boolean) => void;
  successDescription?: string;
  setSuccessDescription: (description: string | undefined) => void;
}

export const ModalContext = createContext<IModalContext | null>(null);

export const ModalProvider: React.FC<IModalProvider> = ({
  children,
  showModal,
  setShowModal,
}) => {
  const [showSuccessComponent, setShowSuccessComponent] = useState(false);
  const [successDescription, setSuccessDescription] = useState<
    string | undefined
  >(undefined);

  return (
    <ModalContext.Provider
      value={{
        showModal,
        setShowModal,
        showSuccessComponent,
        setShowSuccessComponent,
        successDescription,
        setSuccessDescription,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};
